export default "__VITE_ASSET__BCZH7PoD__"